import { ReactElement } from 'react';
import { Stack, DialogContentText } from '@mui/material';

import { useDialogIntegrationAssignWarehousesContext } from '../../Context';

const DialogIntegrationAssignWarehousesEmptyState = (): ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { errorStockLocations } = useDialogIntegrationAssignWarehousesContext();

  return (
    <Stack spacing={2} flex={1} justifyContent="center" alignItems="center">
      <DialogContentText color="text.primary">
        Tu tienda digital no nos permite configurar múltiples depósitos de
        origen.
      </DialogContentText>
    </Stack>
  );
};

export default DialogIntegrationAssignWarehousesEmptyState;
